import script from "./ArticleRelatedVideos.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleRelatedVideos.vue?vue&type=script&setup=true&lang=js"

import "./ArticleRelatedVideos.vue?vue&type=style&index=0&id=63f8f879&lang=css"

const __exports__ = script;

export default __exports__